import { render, staticRenderFns } from "./HistoryDatasetIndex.vue?vue&type=template&id=25176e6c&"
import script from "./HistoryDatasetIndex.vue?vue&type=script&lang=js&"
export * from "./HistoryDatasetIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports